module.exports = __webpack_public_path__ + "static/media/cq_elimina b.04004610.svg";